import { Api } from '../../common/api/const';
import {ShareRequest} from "../model/shareRequest";

export class ShareApiService {
    static generate = (shareRequest: ShareRequest) => Api().post(`/share`, shareRequest)
}